// Apolo IDE — SidebarNavItem (compartilhado entre CodeSidebar e ChatWorkspaceSidebar).
//
// Extraído do CodeSidebar (sprint 2026-08-14) pra que a aba Chat ganhe a MESMA
// linha de navegação (Home/Agenda/Kanban/Integrações/Painel) sem duplicar o
// componente. Square, icon-only nav button. O nome da feature aparece no hover
// (tooltip nativo) + é o nome acessível (aria-label). Sem label/chevron — os
// ícones ficam lado a lado numa linha responsiva (ver o layout <nav> de cada
// sidebar). `collapsed`/`chevron` são aceitos mas ignorados (callers ainda
// passam; inofensivo) pra a linha renderizar igual em qualquer estado.
//
// melhoria-home: ícone na cor do item (--nav-accent), estado ativo "aceso" em
// superfície neutra + accent no ícone, entry/hover minimalistas
// (CodeSidebar.module.css).

import styles from './CodeSidebar.module.css';

export default function SidebarNavItem({ onClick, icon: Icon, label, title, active, accent, index = 0 }) {
  return (
    <button
      type="button"
      onClick={onClick}
      title={title || label}
      aria-label={label}
      aria-current={active ? 'page' : undefined}
      style={{ '--nav-accent': accent || 'var(--apolo-accent)', '--index': index }}
      className={
        'flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-xs transition ' +
        'hover:text-apolo-textPrimary focus:outline-none focus:ring-2 focus:ring-apolo-accent/50 ' +
        styles.navItem + ' ' +
        (active ? styles.navItemActive + ' text-apolo-textPrimary' : 'bg-apolo-surface2/40 text-apolo-textSecondary')
      }
    >
      <Icon size={17} aria-hidden="true" className={styles.navIcon} />
    </button>
  );
}
